<form
  [formGroup]="parentProfileForm"
  (ngSubmit)="submitForm(parentProfileForm)"
  class="w-100"
  style="position: relative"
>
  <div class="ui form">
    <div class="field">
      <label>First name</label>
      <input
        formControlName="first_name"
        type="text"
        placeholder="eg: Chukwudi"
      />
    </div>
    <div class="field">
      <label>Last name</label>
      <input
        formControlName="last_name"
        type="text"
        placeholder="eg: Tosin"
      />
    </div>
    <div class="field">
      <!-- -->

      <div class="field">
        <label>Date Of Birth</label>
        <input
          formControlName="date_of_birth"
          type="date"
          name="class"
          placeholder="Eg: yyyy-mm-dd"
          [max]="maxBirthDay"
        />
      </div>
      <small
        class="dob_warning mb-3"
        [style.display]="dob.touched && !dob.valid && !dob?.errors?.parentIsTooYoung  ? 'block' : 'none'"
      >
        Please enter your date of birth
      </small>
      <small
      class="dob_warning"
      [style.display]="dob?.errors?.parentIsTooYoung ? 'block' : 'none'"
      >
      You must be more than 18 years.
    </small>
    </div>
    <div class="inline fields">
      <label for="fruit">Gender:</label>

      <div class="field">
        <div class="ui radio checkbox">
          <input
            type="radio"
            id="male"
            formControlName="gender"
            name="gender"
            tabindex="0"
            value="1"
            class="hidden"
          />
          <label for="male">Male</label>
        </div>
      </div>
      <div class="field">
        <div class="ui radio checkbox">
          <input
            type="radio"
            id="female"
            formControlName="gender"
            value="2"
            name="gender"
            tabindex="0"
            class="hidden"
          />
          <label for="female">Female</label>
        </div>
      </div>
    </div>

    <div class="field">
    </div>
  </div>

  <div class="text-center mt-4">
    <button
      [disabled]="!parentProfileForm.valid"
      type="submit"
      class="ui primary button fluid"
    >
      Next
    </button>
  </div>
</form>
